const KEEPALIVE_FIELD_I18N_KEYS = {
  SPEED: 'bike.name522',
  GSP_SPEED: 'bike.name501',
  LNG: 'bike.name525',
  LAT: 'bike.name526',
  ALT: 'bike.name500',
  BATTERY_VOLTAGE: 'bike.name9',
  BATTERY_CURRENT: 'bike.name10',
  CONTROLLER_TEMP: 'bike.name523',
  SOC: 'bike.name499',
  BATTERY_TEMP: 'bike.name503',
  MOTOR_TEMP: 'bike.name524',
  POWER_PERCENT: 'bike.name507',
  CADENCE: 'bike.name509'
}

function normalizeUnit (unit) {
  if (unit === '度') return '℃'
  return unit
}

export function getKeepAliveFieldDisplayName (vm, field) {
  if (!field) return ''
  const key = KEEPALIVE_FIELD_I18N_KEYS[field.id]
  const label = key ? vm.$t(key) : field.name
  if (key && /\([^)]+\)/.test(label)) {
    return label
  }
  if (field.unit) {
    return `${label}(${normalizeUnit(field.unit)})`
  }
  return label
}

export function localizeKeepAliveFields (vm, fields) {
  return (fields || []).map((field) => ({
    ...field,
    name: getKeepAliveFieldDisplayName(vm, field)
  }))
}

export function rebuildKeepAliveLegend (vm, typeOptions, selectedIds) {
  const legend = []
  ;(selectedIds || []).forEach((id) => {
    const field = (typeOptions || []).find((item) => item.id === id)
    if (field) {
      legend.push(getKeepAliveFieldDisplayName(vm, field))
    }
  })
  return legend
}
